module.exports = __webpack_public_path__ + "themify.cba68f986e60df8c74f4.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.svg?-fvbane
// module chunks = styles